import { getPlayerInfo } from 'services/dashboard.service';

// Cache em memória (escopo de módulo) do find/info com pares, por gestor exibido.
// Motivo: a troca de aba MAD⇄Diretoria desmonta e remonta o fluxo, e o playerInfo era
// rebuscado na rede a cada montagem — segurando a guarda de render (tela de loading).
// Os dados de player_fields (cod_etapa, mad_dupla, is_manager) são estáveis dentro de
// uma sessão curta; TTL de 5min espelha o cache de elegibilidade. Um refresh da página
// zera o módulo e refaz a chamada.
const PLAYER_INFO_TTL_MS = 5 * 60 * 1000;

interface PlayerInfoCacheEntry {
  info: any;
  timestamp: number;
}

const cache = new Map<string, PlayerInfoCacheEntry>();

// Assinatura fechada nos argumentos que AMBOS os fluxos usam (cycle null, showPairs
// true) — não cachear variações evita servir o objeto errado a outros consumidores.
export async function getPlayerInfoWithPairs(chave: string): Promise<any> {
  const cached = cache.get(chave);

  if (cached && Date.now() - cached.timestamp <= PLAYER_INFO_TTL_MS) {
    return cached.info;
  }

  const info = await getPlayerInfo(chave, null, true);

  if (info) {
    cache.set(chave, { info, timestamp: Date.now() });
  }

  return info;
}

// Para testes e para invalidação explícita (ex.: pós-ações que alterem player_fields).
export function clearPlayerInfoCache() {
  cache.clear();
}
